import BaseDocumentRequest from "../../components/BaseDocumentRequest/BaseDocumentRequest";
import { cwaConfig } from "../../components/BaseDocumentRequest/config/cwaConfig";

const CertificateOfWorkAccomplishment = () => {
  return <BaseDocumentRequest {...cwaConfig} />;
};

export default CertificateOfWorkAccomplishment;
